import { Paper, styled } from '@mui/material';

export const StyledVisualGuideWrapper = styled(Paper)(() => ({
	display: 'flex',
	flexDirection: 'column',
	borderRadius: '16px',

	gap: '20px',
	padding: '8px',
}));

export const StyledIcon = styled('img')(() => ({
	width: '27px',
}));
